import type { Page } from '../../types';

const businessObjective: Page[] = [
  {
    pageType: 'list',
    title: 'Business Objectives',
    name: 'business-objective',
    description: 'Please add all of your business objectives to this section.',
    hidePageTitle: true,
    listLabel: 'Objective',
    addButton: true,
    questions: [
      {
        questionType: 'textarea',
        textRows: 20,
        title: 'Business Objective - What',
        name: 'business-objective-what',
        hint: "Please add all of your business objectives to this section. You will be able to add in additional objectives by clicking 'Save and add another' below.",
        placeholder:
          'EXAMPLE: To publish a White Paper on the future of Probation Services by November 2026',
        wordCount: 250,
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        textRows: 20,
        title: 'Business Objective - How',
        name: 'business-objective-how',
        placeholder: `EXAMPLE:
- Invest in the development of my project-delivery skills within my Directorate to ensure accountability and responsibility is built in to deliver against set milestones and the team are working towards a shared aim.
- Reskill existing team, avoiding the need for further investment in resources.
- Engage cross-government with the Home Office and MHCLG on the scope of review and ensure joined-up ambition in this area.
- Consult with local authorities and relevant social enterprises to identify innovative approaches and alternative perspectives on existing approaches.
- Consult MoJ Digital to understand how the use of Workforce Management Tool could automate caseload in order to increase efficiency.`,
        wordCount: 250,
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default businessObjective;
